import { AppBar, Grid, Typography } from "@mui/material";
import PrimaryButton from "../shared/PrimaryButton";
import CustomIcon from "../shared/CustomIcon";
import exportIcon from "../../assets/icons/exportIcon.svg";

const ExportButton = (props) => {
  return (
    <PrimaryButton startIcon={<CustomIcon svgIcon={exportIcon} />} {...props}>
      Export
    </PrimaryButton>
  );
};
/**
 *
 * @param {String} headLine main headline of the screen/route
 * @returns
 */
const Header = ({ headLine, action = null, children }) => {
  const Buttons = {
    export: <ExportButton onClick={() => console.log("Export")} />,
  };
  return (
    <AppBar
      sx={{
        marginTop: "48px",
        backgroundColor: "#FFFFFF",
        height: "60px",
        borderBottom: "solid",
        borderBottomColor: "#E7E9EF",
        borderBottomWidth: "thin",
      }}
      elevation={0}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{
          marginLeft: "240px",
          height: "60px",
          paddingLeft: "24px",
          paddingRight: "24px",
        }}
      >
        <Grid item xs={6}>
          <Typography
            sx={{
              color: "#050D2E",
              fontWeight: "550",
              fontSize: "20px",
              lineHeight: "24px",
            }}
          >
            {headLine}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            {action && <Grid item>{Buttons[action]}</Grid>}
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default Header;
